export default {
  organization: [
    {
      id: 'beta-applications',
      description:
        'List all applications, including unreleased beta applications.',
    },
    {
      id: 'guest-role',
      description: 'Add ability to invite or switch members to guest role',
    },
  ],

  user: [
    {
      id: 'confluence-import',
      description: 'Add ability to import confluence spaces.',
    },
    {
      id: 'debug',
      description: 'Display the debug banner.',
    },
    {
      id: 'editor-next',
      description: 'Start using upcoming features in next editor',
    },
    {
      id: 'database',
      description: 'Ability to add and display Databases',
    },
    {
      id: 'merge-share-and-permissions',
      description: 'Merge the channel permissions and share settings tabs',
    },
  ],
}
